<template>
  <!-- Show loading screen while authenticating -->
  <LoadingScreen v-if="loading && !hasResult" />

  <!-- Show welcome screen for anonymous users -->
  <WelcomeScreen v-else-if="!loading && !currentUser" />

  <!-- Show content for authenticated users -->
  <slot v-else />
</template>

<script setup>
import { computed } from 'vue'
import LoadingScreen from './LoadingScreen.vue'
import WelcomeScreen from './WelcomeScreen.vue'

const props = defineProps({
  /**
   * Whether authentication is currently loading
   */
  loading: {
    type: Boolean,
    required: true,
  },
  /**
   * Current user object (null if not authenticated)
   */
  currentUser: {
    type: Object,
    default: null,
  },
  /**
   * Whether we have received a result from the auth query
   * (used to distinguish between "loading" and "no result yet")
   */
  hasResult: {
    type: Boolean,
    default: false,
  },
})
</script>
